import { TableContainer } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export default function CasTableContainer({ children }: Props) {
  return (
    <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>{children}</TableContainer>
  );
}
